import { CompanyToContactApi } from "queries/CompanyToContact";
import React from "react";
import Attendees from "show/components/ArtistAttendeePicker/Attendees";
import PotentialAttendees from "show/components/ArtistAttendeePicker/PotentialAttendees";

interface Props {
  artistId: number;
  attendees: server.dto.ContactSmallV2[];
  onAttendeesChange: (attendees: server.dto.ContactSmallV2[]) => void;
  canCreate: boolean;
}

const AttendeePicker = (props: Props) => {
  const { data } = CompanyToContactApi.ListContactByCompany.useQuery({
    companyId: props.artistId,
    page: 1,
    perPage: 1000,
    isActive: true
  }, {
    enabled: props.artistId != null
  });

  const potentialAttendees = React.useMemo(
    () => data?.data?.map(c => c.contact) ?? [],
    [data]
  );

  const onAttendeeAdded = (attendee: server.dto.ContactSmallV2) => {
    props.onAttendeesChange([...props.attendees, attendee]);
  };

  const onAttendeeEdited = (attendee: server.dto.ContactSmallV2) => {
    const idx = props.attendees.findIndex(a => a.contactId === attendee.contactId);
    const newAttendees = Object.assign([], props.attendees, { [idx]: attendee });
    props.onAttendeesChange(newAttendees);
  };

  const onAttendeeRemoved = (attendee: server.dto.ContactSmallV2) => {
    const newAttendees = props.attendees.filter(a => a.contactId !== attendee.contactId);
    props.onAttendeesChange(newAttendees);
  };

  return <div className="flex-column gap-small">
    <div className="s1_gray">{RESX.Planning.Attendees}</div>

    <div className="flex gap-large">
      <div style={{ flex: "1 0 50%" }}>
        <Attendees
          attendees={props.attendees}
          onAttendeeAdded={onAttendeeAdded}
          onAttendeeEdited={onAttendeeEdited}
          onAttendeeRemoved={onAttendeeRemoved}
          canCreate={props.canCreate}
        />
      </div>
      <div style={{ flex: "1 0 50%" }}>
        <PotentialAttendees
          selectedAttendees={props.attendees}
          potentialAttendees={potentialAttendees}
          onAttendeeSelected={onAttendeeAdded}
        />
      </div>
    </div>
  </div>;
};

export default AttendeePicker;
